"use client"

import BaseFormProvider from '../../../../../shared/components/forms/base-form-provider'
import { signupFormSchema } from '@/features/auth/schemas/signup.schema'
import { SignupFormType } from '@/features/auth/types/signup.type'
import React, { PropsWithChildren } from 'react'

interface SignupFormProviderProps extends PropsWithChildren {
    defaultValues?: Partial<SignupFormType>
}

function SignupFormProvider({children, defaultValues}: SignupFormProviderProps) {
    const onSubmit = (data: SignupFormType) => {
    }
    
    // Merge provided default values with base defaults
    const mergedDefaultValues: Partial<SignupFormType> = {
        form1: {
            fullname: "",
            phone: "",
            email: "",
            password: "",
            confirmPassword: "",
            ...defaultValues?.form1,
        },
    }
    
    return (
        <BaseFormProvider
            schema={signupFormSchema}
            formOptions={{
                mode: "onChange",
            }}
            onSubmit={onSubmit}
            defaultValues={mergedDefaultValues}
        >
            {children}
        </BaseFormProvider>
    )
}

export default SignupFormProvider